import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed} from 'vue';
import SideMenuList from "~/chat/vue/widget/sideMenu/SideMenuList.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatHistoryTitle from "~/chat/vue/widget/tabs/chat/ChatHistoryTitle.vue";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import ChatHideLink from "~/chat/vue/widget/tabs/chat/ChatHideLink.vue";


const __default__ = {
    name: "WidgetMenuInChat"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const HIDE_KEY = "hideWidgetMenuInChat";

let config = computed(() => {
    return ConfigStore.siteParams.value.params.siteChatOptions.widgetMenuInChat;
});

let isEnabled = computed(() => {
    return config.value.enabled;
});

let visitId = computed(() => {
    return ConfigStore.visitId.value;
});

function hide() {
    return StorageInstance.set(HIDE_KEY, visitId.value);
}

let isHidden = computed(() => {
    return StorageInstance.get(HIDE_KEY) === visitId.value;
});


return (_ctx: any,_cache: any) => {
  return (_unref(isEnabled) && !_unref(isHidden))
    ? (_openBlock(), _createBlock(SideMenuList, {
        key: 0,
        class: "text-left widget-menu-in-chat margin-in-chat-block",
        "except-chat": ""
      }, _createSlots({
        after: _withCtx(() => [
          _createVNode(ChatHideLink, { onClick: hide })
        ]),
        _: 2
      }, [
        (_unref(config).title)
          ? {
              name: "before",
              fn: _withCtx(() => [
                _createVNode(ChatHistoryTitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(config).title), 1)
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1024))
    : _createCommentVNode("", true)
}
}

})